export const WHATS_NEW_CAROUSEL_IMAGE_FIT_OPTIONS = ['top'] as const;

export type WhatsNewCarouselImageFit = (typeof WHATS_NEW_CAROUSEL_IMAGE_FIT_OPTIONS)[number];

export interface WhatsNewCarouselCard {
  draftId: string;
  draftLabel: string;
  isActive: boolean;
  enabledRegions: Array<string>;
  startAt: string;
  endAt: string;
  imageId: string;
  imageOptionsFit: WhatsNewCarouselImageFit | '';
  overline: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaUrl: string;
  openInNewTab: boolean;
  optimizelyFeatureFlag: string;
}

export interface WhatsNewCarouselPayloadBuilderState {
  mode?: 'whatsNewCarousel';
  cards: Array<WhatsNewCarouselCard>;
}
